// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.changevariantdetail', {
        url:'/changevariantdetail',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/changevariantdetail/changevariantdetail.tpl.html',
            controller: 'SupportCaseChangeVariantDetailController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseChangeVariantDetailController($state, $scope, SupportApiService,ArticleChangeVariantDetailDialogService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.selectedProduct = {};

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.openEditVariantDetailDialog = openEditVariantDetailDialog;

    activate();

    function activate() {
    }

    function openEditVariantDetailDialog(){
        ArticleChangeVariantDetailDialogService.showDialog(vm.selectedProduct).then(function(response){
            if(response)
                $state.go($state.current.name,{},{reload: $state.current.name});
        });
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
        loadSpinnerService.start("mainSpinner");
        SupportApiService.getProduct(vm.selectedProduct.id).then(function(response) {
            vm.selectedProduct = response;
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
}

angular
    .module('supportcases.changevariantdetail', ['support.api', 'product.articles.articleChangeVariantDetailDialog'])
    .config(stateConfig)
    .controller('SupportCaseChangeVariantDetailController', SupportCaseChangeVariantDetailController);